export const booConvertSelect = {
  false: 1,
  true: 2
};
